import { useLibEdit } from '@apis/queryHooks/useLibEdit';
import Button from '@components/Button';
import { $sceneMapApi } from '@stores/dataStores';
import { MainPlayer } from '@stores/krpPlayerStores';
import { $loadedScene } from '@stores/loadedStore';
import { $viewMode } from '@stores/viewModeStores';
import { LibType, SceneType } from '@types';
import { useStore } from 'effector-react';
import { useRef } from 'react';
import { CompassWidget } from './CompassWidget';
import ImgMobile from './img-block-mobile.png';
import ImgBlock from './img-block.png';

function NorthViewCaptureWidget() {
  const scene = useStore($loadedScene);
  const viewMode = useStore($viewMode);
  const northRef = useRef<number>(scene?.north || 0);
  const { editLib, editLibLoading } = useLibEdit();

  if (!scene) return null;
  if (scene.type === SceneType.panoVideo || scene.type === SceneType.matrix)
    return null;

  const handleSetNorth = async () => {
    const playerRef = MainPlayer.get();
    if (!playerRef) return;
    const ath = (playerRef.getView().hlookat ?? 0) % 360;
    await editLib({
      libType: LibType.pano,
      id: scene.materialId,
      data: { north: ath },
    });
    northRef.current = ath;
    $sceneMapApi.update((draft) => {
      [...draft.values()].forEach((x) => {
        if (x.materialId === scene.materialId) {
          x.north = ath;
        }
      });
    });
  };

  return (
    <>
      <CompassWidget viewMode={viewMode} />
      {viewMode === 'pc' && (
        <img
          src={ImgBlock}
          draggable={false}
          className="pointer-events-none absolute"
          style={{ width: 704, height: 404 }}
          alt=""
        />
      )}
      {viewMode === 'mobile' && (
        <img
          src={ImgMobile}
          draggable={false}
          className="pointer-events-none absolute"
          style={{ width: 260, height: 400 }}
          alt=""
        />
      )}
      <Button
        disabled={editLibLoading}
        className="absolute mt-300"
        onClick={handleSetNorth}
      >
        {editLibLoading ? '设置中' : '把当前视角设为正北'}
      </Button>
    </>
  );
}

export default NorthViewCaptureWidget;
